var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 510.684 510.684",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#a3e0fb",
    d: "M414.747 296.162a176.364 176.364 0 0 1 2.312 28.548c0 97.181-78.783 175.974-175.974 175.974S65.111 421.891 65.111 324.71c0-39.097 12.756-75.21 34.316-104.42l.011-.021L241.085 10l90.771 134.744",
    opacity: 1,
    "data-original": "#a3e0fb"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4696e6",
    d: "M288.068 233.678c0-17.5 5.704-33.661 15.356-46.733l.005-.01 63.391-94.104 63.391 94.104.005.01c9.652 13.071 15.356 29.233 15.356 46.733 0 43.491-35.256 78.753-78.753 78.753s-78.751-35.261-78.751-78.753z",
    opacity: 1,
    "data-original": "#4696e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.242 439.486c-49.257-15.316-82.352-60.297-82.352-111.931 0-25.238 7.901-49.283 22.85-69.536.341-.462.649-.967.906-1.481 2.47-4.939.464-10.938-4.476-13.408-4.471-2.239-9.819-.801-12.625 3.153-17.437 23.688-26.654 51.788-26.654 81.272 0 29.858 9.428 58.247 27.264 82.095 17.24 23.051 41.797 40.43 69.149 48.934a9.98 9.98 0 0 0 2.972.454c4.263 0 8.214-2.749 9.546-7.034 1.64-5.274-1.306-10.878-6.58-12.518z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.573 233.679c0-19.035-5.932-37.17-17.158-52.464l-63.301-93.971a10 10 0 0 0-16.588 0l-26.674 39.597L249.378 4.413a9.998 9.998 0 0 0-16.586 0L91.216 214.576c-23.622 32.101-36.105 70.177-36.105 110.134 0 102.546 83.428 185.974 185.974 185.974s185.974-83.428 185.974-185.974c0-8.186-.547-16.387-1.61-24.46 18.458-16.276 30.124-40.085 30.124-66.571zM366.82 110.73l55.005 81.654c.11.17.226.337.347.501 8.767 11.873 13.401 25.979 13.401 40.793 0 37.91-30.842 68.752-68.753 68.752-37.91 0-68.752-30.842-68.752-68.752 0-14.814 4.634-28.92 13.401-40.793.116-.157.227-.317.334-.482l28.323-42.045c.052-.077.106-.153.156-.232zm40.238 213.98c0 91.519-74.456 165.974-165.974 165.974-91.519 0-165.974-74.455-165.974-165.974 0-35.744 11.19-69.799 32.362-98.481.121-.163.238-.334.351-.509L241.085 27.898l78.711 116.842-24.571 36.476c-11.225 15.293-17.157 33.429-17.157 52.463 0 48.938 39.814 88.752 88.752 88.752 14.31 0 27.837-3.409 39.819-9.45.273 3.9.419 7.816.419 11.729z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.561 231.24c0-4.845.987-9.521 2.933-13.898 2.244-5.047-.029-10.957-5.075-13.2-5.047-2.241-10.956.028-13.2 5.075-3.091 6.952-4.658 14.361-4.658 22.023 0 18.149 9.016 35.019 24.117 45.123a9.95 9.95 0 0 0 5.552 1.689 9.99 9.99 0 0 0 8.32-4.439c3.071-4.591 1.84-10.802-2.75-13.873-9.542-6.385-15.239-17.039-15.239-28.5zM236.343 453.34c-2.448-6.434-11.582-8.269-16.31-3.24-5.629 5.455-2.599 15.471 5.12 16.87 7.653 1.677 14.324-6.446 11.19-13.63zM361.552 285.479c6.448 4.466 15.682-.472 15.55-8.31.145-7.839-9.107-12.787-15.55-8.32-5.84 3.66-5.863 12.982 0 16.63z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulag);
export default __webpack_public_path__ + "static/media/bulag.24bba3ba619884db7ad74a1000566b93.svg";
export { ForwardRef as ReactComponent };